module.exports = __webpack_public_path__ + "static/media/pdfImage.81026b37.png";